import { GenericDTO } from '../types/GenericDTO';

export class Account extends GenericDTO {
  public activated: boolean;
}
